import Dictionary from "./Dictionary.js";

function App() {
  return (
    <div className="App">
      <main>
        <Dictionary defaultKeyword="hello" />
      </main>
    </div>
  );
}

export default App;
